/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-10 10:26:49
 * @LastEditTime: 2025-04-07 10:11:56
 * @LastEditors: Please set LastEditors
 */
import React from "react";
import { Modal, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import './index.scss';

interface IProcess { 
  isTimeOut: boolean,
  setIsTimeOut: (isTimeOut: boolean) => void,
  title:string,
  type:string,
  btnText?:string
}


const TipsModal: React.FC<IProcess> = (props) => {
  const { isTimeOut, setIsTimeOut ,title,type,btnText} = props;
  const navigate = useNavigate();
  const handleCancel = () => { 
    setIsTimeOut(false);
  }

  const handleOk = () => { 
    setIsTimeOut(false);
  }
  const handleMyOrder = () => { 
    if (type === 'timeOut') {
      setIsTimeOut(false);
      navigate('/user/orderList');
    } else { 
      setIsTimeOut(false);
      window.location.reload();
    }
  
}
 
  return (
    <Modal
      centered
      closable={false}
      maskClosable={ false}
    width={450}
    title={'订单提醒'}
    open={isTimeOut}
    // initialValues={editModalState}
    cancelText="取消"
    okText="确定"
    onCancel={handleCancel}
    onOk={handleOk}
    className="payment-tips-modal"
    >
      <p className="title">{ title}</p>
      <div className="dialog-bottom">

        {type === 'fail' ?<Button onClick={handleMyOrder}>关闭</Button>: <Button onClick={handleMyOrder}>{btnText??'返回'}</Button>}

      </div>
    </Modal>
  )

}

export default TipsModal;
